/**
 * Zjistí jestli url a funkce obsahují pouze statické metody
 * @param url Šablona url adresy
 * @param functions Pole názvů funkcí
*/
export const canCallOnlyStaticMethods = (url: string, functions: ReadonlyArray<string>): boolean => {
    for (let i = 0; i < url.length - 1; i++) {
        if (url[i] === "@") {
            if (url[i + 1] !== "@") {
                return false;
            }
            i++;
        }
    }

    if (functions.some(f => !f.includes("."))) {
        return false;
    }

    return true;
};
